import { GroupAdd } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import SelectionTable from "./SelectionTable";
import { TraineeEvaluationDto } from "../../../types/applicationTypes";

/**
 * The TraineeSelectionProps interface defines the props for the TraineeSelection component
 */
interface TraineeSelectionProps {
  applicantsEvaluations: TraineeEvaluationDto[];
  selectedApplicants: TraineeEvaluationDto[];
  setSelectedApplicants: React.Dispatch<React.SetStateAction<TraineeEvaluationDto[]>>;
  handleAdmitTrainees: () => void;
}

/**
 * The TraineeSelection component displays a table with all applicants and the possibility to select them for the selection weekend
 * @param applicantsEvaluations The evaluations of the applicants
 * @param selectedApplicants The selected applicants
 * @param setSelectedApplicants The function to set the selected applicants
 * @param handleAdmitTrainees The function to admit the selected trainees
 * @returns The TraineeSelection component
 */
const TraineeSelection = ({
  applicantsEvaluations,
  selectedApplicants,
  setSelectedApplicants,
  handleAdmitTrainees,
}: TraineeSelectionProps) => {
  return (
    <Stack spacing={2}>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
        <Typography variant="h6" fontWeight={"bold"}>
          Aufnahme von Bewerbern als Trainee
        </Typography>
        <Button variant="contained" size="small" onClick={handleAdmitTrainees}>
          <GroupAdd sx={{ mr: 2 }} />
          Trainees aufnehmen
        </Button>
      </Stack>
      <Typography>
        Bitte wähle die Bewerber aus, die als Trainee aufgenommen werden sollen. Alle Änderungen werden{" "}
        <strong>sofort gespeichert</strong>.
        <br />
        Wenn du fertig bist, klicke bitte auf den obigen Button. Dadurch wird für jeden erfolgreichen Bewerber ein
        MDB-Account mit zufälligem Passwort erstellt. Dieses wird ihm per Mail an die neue JBT-E-Mail-Adresse geschickt,
        die daher zuvor erstellt werden sollte. Außerdem wird das MDB-Profil mit den Daten aus der Bewerbung
        vorausgefüllt.
        <br />
        <br />
        <strong>Wichtig:</strong> Alle Bewerber sollten von allen Bewertern bewertet worden sein. Da sich die
        Gesamtbewertung als Summe berechnet, hätte ein Bewerber sonst weniger Punkte.
        <br />
        <br />
        Es wurden {selectedApplicants.length} von {applicantsEvaluations.length} interviewten Bewerbern ausgewählt.
        Weitere {applicantsEvaluations.filter((applicant) => applicant.toBeAdmitted).length} Bewerber wurden bereits als
        Trainee aufgenommen.
      </Typography>
      <SelectionTable
        applicantsEvaluations={applicantsEvaluations}
        selectedApplicants={selectedApplicants}
        setSelectedApplicants={setSelectedApplicants}
        tableType="admit"
      />
    </Stack>
  );
};

export default TraineeSelection;
